import {Modal} from '@mantine/core';
import {BasicButton} from '@packages/ui';
import {useRouter} from 'next/router';
import type {FC} from 'react';
import {LOGIN} from '../../config/constants/routes';
import {QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE} from '../../core/entities/login/constants';
import {useAuth} from '../../core/usecases/auth/AuthContext';
import {isStudentVerified as checkStudentVerified} from '../../core/usecases/auth/isStudentVerified';
import {useIsAppWebView} from '../hooks/useIsAppWebView';
import {getMailAuthLinkWithParamsHooks} from '../services/getMailAuthLinkWithParamsHooks';
import {NotStudentVerifiedAlertModal} from './NotStudentVerifiedAlertModal';

type Props = {
  opened: boolean;
  onClose: () => void;
};

export const NoLoginAlertModal: FC<Props> = (props) => {
  const isWebView = useIsAppWebView();
  const router = useRouter();
  const mailAuthLink = getMailAuthLinkWithParamsHooks({});
  const {user} = useAuth();

  // 大学認証が未完了のユーザーは未ログイン相当の表示に出し分けられるためこのモーダルに到達するが、
  // 会員登録は済んでいるので新規会員登録ではなく大学認証へ誘導する。
  // 未ログイン相当への出し分け自体が新登録フローのリリース後にのみ行われるため(withHandler)、
  // 同じフラグを内包する checkStudentVerified で判定し、未リリース時はこの分岐に入らない。
  if (!checkStudentVerified(user)) {
    return <NotStudentVerifiedAlertModal {...props} />;
  }

  return (
    <Modal
      opened={props.opened}
      onClose={props.onClose}
      title=""
      size="md"
      padding="md"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="text-center">
        <p className="mb-[20px]">
          会員限定機能です。
          アカウントをお持ちでない方は新規会員登録を行ってください。
        </p>
      </div>
      <div className="flex justify-around">
        <BasicButton
          label="ログイン"
          isPrimary={true}
          className="mx-8"
          onClick={async () => {
            const path = `${LOGIN}?${QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE}=${router.asPath}`;
            if (isWebView) {
              location.href = path;
            } else {
              await router.push(path);
            }
          }}
        />
        <BasicButton
          label="新規登録"
          isPrimary={false}
          className="mx-12"
          onClick={() => {
            location.href = mailAuthLink;
          }}
        />
      </div>
    </Modal>
  );
};
